import React from 'react';
import PropTypes from 'prop-types';

const CallingSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 16}`}
      height={`${height || 16}`}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
    <path
      d="M14.6468 12.22C14.6468 12.46 14.5935 12.7066 14.4802 12.9466C14.3668 13.1866 14.2202 13.4133 14.0268 13.6266C13.7002 13.9866 13.3402 14.2466 12.9335 14.4133C12.5335 14.58 12.1002 14.6666 11.6335 14.6666C10.9535 14.6666 10.2268 14.5066 9.46016 14.18C8.6935 13.8533 7.92683 13.4133 7.16683 12.86C6.40016 12.3 5.6735 11.68 4.98016 10.9933C4.2935 10.3 3.6735 9.57331 3.12016 8.81331C2.5735 8.05331 2.1335 7.29331 1.8135 6.53998C1.4935 5.77998 1.3335 5.05331 1.3335 4.35998C1.3335 3.90665 1.4135 3.47331 1.5735 3.07331C1.7335 2.66665 1.98683 2.29331 2.34016 1.95998C2.76683 1.53998 3.2335 1.33331 3.72683 1.33331C3.9135 1.33331 4.10016 1.37331 4.26683 1.45331C4.44016 1.53331 4.5935 1.65331 4.7135 1.82665L6.26016 4.00665C6.38016 4.17331 6.46683 4.32665 6.52683 4.47331C6.58683 4.61331 6.62016 4.75331 6.62016 4.87998C6.62016 5.03998 6.5735 5.19998 6.48016 5.35331C6.3935 5.50665 6.26683 5.66665 6.10683 5.82665L5.60016 6.35331C5.52683 6.42665 5.4935 6.51331 5.4935 6.61998C5.4935 6.67331 5.50016 6.71998 5.5135 6.77331C5.5335 6.82665 5.5535 6.86665 5.56683 6.90665C5.68683 7.12665 5.8935 7.41331 6.18683 7.75998C6.48683 8.10665 6.80683 8.45998 7.1535 8.81331C7.5135 9.16665 7.86016 9.49331 8.2135 9.79331C8.56016 10.0866 8.84683 10.2866 9.0735 10.4066C9.10683 10.42 9.14683 10.44 9.1935 10.46C9.24683 10.48 9.30016 10.4866 9.36016 10.4866C9.4735 10.4866 9.56016 10.4466 9.6335 10.3733L10.1402 9.87331C10.3068 9.70665 10.4668 9.57998 10.6202 9.49998C10.7735 9.40665 10.9268 9.35998 11.0935 9.35998C11.2202 9.35998 11.3535 9.38665 11.5002 9.44665C11.6468 9.50665 11.8002 9.59331 11.9668 9.70665L14.1735 11.2733C14.3468 11.3933 14.4668 11.5333 14.5402 11.7C14.6068 11.8666 14.6468 12.0333 14.6468 12.22Z"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M12.3333 5.99996C12.3333 5.59996 12.02 4.98663 11.5533 4.48663C11.1267 4.02663 10.56 3.66663 10 3.66663"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6667 5.99998C14.6667 3.41998 12.58 1.33331 10 1.33331"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    </svg>
  );
};

CallingSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default CallingSvg;
